import React, { useContext, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

import { ReactComponent as HappyBuddy } from '../../../assets/icons/buddy-happy-open-eyes.svg';
import BdsModal from '../../../shared/components/v3/Modals/BdsModal/BdsModal';
import Toast from '../../../shared/components/v3/Toast/Toast';
import { DEFAULT_TOAST_DATA, NOTIFY_ADD_FOUNDS_SUCCESS_TOAST } from '../../../shared/constants/toast';
import { IToast } from '../../../shared/interfaces/toast';
import { FLEXIBLE_REMUNERATION_TRANSLATIONS } from '../../../shared/translations/flexibleRemuneration';
import HomeBanner from '../sections/Banner/CompanyBanner';
import DirectAccess from '../sections/DirectAccess/DirectAccess';
import RedirectionsCards from '../sections/RedirectionCards/RedirectionsCards';
import BalanceCard from './sections/BalanceCard/BalanceCard';
import MetricsCard from './sections/MetricsCard/MetricsCard';
import Ranking from './sections/Ranking/Ranking';
import { PlansContext } from '../../../shared/context/plans/plansContext';

import './RFHome.scss';

interface LocationState {
  showBalanceModal?: boolean;
  showBalanceToast?: boolean;
}

const RFHome = () => {
  const [showBalanceModal, setShowBalanceModal] = useState<boolean>(false);
  const [showBalanceToast, setShowBalanceToast] = useState<boolean>(false);
  const [toast, setToast] = useState<IToast>(DEFAULT_TOAST_DATA);

  const { modelType } = useContext(PlansContext);

  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location as { state: LocationState | null };
  const { t } = useTranslation();

  useEffect(() => {
    if (state?.showBalanceModal) {
      setShowBalanceModal(true);
      navigate(location.pathname, { replace: true, state: {} });
    }
    if (state?.showBalanceToast) {
      setToast(NOTIFY_ADD_FOUNDS_SUCCESS_TOAST);
      setShowBalanceToast(true);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [state, location.pathname, navigate]);

  return (
    <div className="rf-home-container">
      <div className={modelType === 'forecast' ? 'rf-first-component-full-width' : 'rf-first-component'}>
        <DirectAccess />
      </div>
      {modelType !== 'forecast' && (
        <div className="rf-second-component">
          <BalanceCard />
        </div>
      )}
      <div className="rf-third-component">
        <MetricsCard />
      </div>
      <div className={modelType === 'forecast' ? 'rf-fourth-component-full-height' : 'rf-fourth-component'}>
        <Ranking />
      </div>
      <div className="rf-fifth-component">
        <HomeBanner />
      </div>
      <div className="rf-sixth-component">
        <RedirectionsCards />
      </div>
      <BdsModal
        open={showBalanceModal}
        title={t(FLEXIBLE_REMUNERATION_TRANSLATIONS.balanceModal.title)}
        description={t(FLEXIBLE_REMUNERATION_TRANSLATIONS.balanceModal.description)}
        icon={<HappyBuddy />}
        onClose={() => setShowBalanceModal(false)}
        primaryAction={{
          label: t(FLEXIBLE_REMUNERATION_TRANSLATIONS.balanceModal.button),
          onClick: () => setShowBalanceModal(false)
        }}
      />
      <Toast
        title={t(toast.title)}
        description={t(toast.description)}
        icon={toast.icon}
        open={showBalanceToast}
        button={true}
        handleClose={() => setShowBalanceToast(false)}
      />
    </div>
  );
};

export default RFHome;
